<script setup lang="ts">

import {XIcon} from "lucide-vue-next";
import {computed, type Ref, ref } from "vue";
import {toast} from "vue-sonner";
import Button from "../../../backend/ui/Button.vue";
import Input from "../../../backend/ui/Input.vue";
import {label} from "../../mixins/translations.ts";
import {useCartStore} from "../../stores/cart.ts";
import FormError from "../FormError.vue";


type Props = {}

defineProps<Props>()


const cartStore = useCartStore();

const discountCode: Ref<string> = ref('');
const errorMessage: Ref<string> = ref('');
const showInput : Ref<boolean> = ref(false);

const discounts = computed(() => {
    return cartStore.getDiscounts();
});


const submitCode = async () => {
    errorMessage.value = '';
    await cartStore.validateDiscountCode({ discountCode: discountCode.value}).then((response) => {
        if(response.data.valid) {
            toast.success(response.data.message);
            showInput.value = false;
            discountCode.value = '';
        } else {
            errorMessage.value = response.data.message;
        }
    }).catch((response) => {
        errorMessage.value = response.data.message;
    })
}

const removeCode = async (code) => {
    await cartStore.deleteDiscountCode({ discountCode: code}).then((response) => {
    }).catch((response) => {
        errorMessage.value = response.data.message;
    })
}

</script>

<template>
    <div class="max-w-xl">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center border border-gray-200 rounded-full p-2">
            <input
                v-model="discountCode"
                type="text"
                :placeholder="label('site.cart.discount_code')"
                class="h-12 w-full rounded-full border-0 ring-0 bg-transparent px-5 text-sm text-secondary-700 outline-none placeholder:text-secondary-400 focus:border-primary-400"
            />
            <button
                @click.prevent="submitCode"
                type="button"
                class="inline-flex h-12 items-center justify-center rounded-full bg-secondary-700 px-8 text-base font-medium text-white transition hover:bg-secondary-800"
            >
                {{ label('site.cart.discount_code.apply') }}
            </button>
        </div>
        <FormError :error="errorMessage" class="pl-2 pt-1"></FormError>

        <div class="space-y-3 text-sm text-slate-800 sm:text-base mt-2 px-5">
            <div class="flex items-center justify-between gap-4" v-for="discount in discounts">
                <div v-text="discount.code"></div>
                <div class="cursor-pointer bg-red-50 text-red-400 hover:bg-red-100 p-1" @click="removeCode(discount.code)">
                    <XIcon class="h-4 w-4" />
                </div>
            </div>
        </div>
    </div>

</template>
